import { render } from "./Management.vue?vue&type=template&id=27254e46&scoped=true"
import script from "./Management.vue?vue&type=script&lang=js"
export * from "./Management.vue?vue&type=script&lang=js"

import "./Management.vue?vue&type=style&index=0&id=27254e46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27254e46"]])

export default __exports__